import React from 'react';
import PropTypes from 'prop-types';
import translate from '../../../../commonComponents/translate';
import LevelCard from './LevelCard';

const LevelObjectives = props => {
  const { t, data } = props;

  return (
    <div className="level-objectives">
      <div className="level-objectives-header">
        <div className="career-section-title">
          {t('report.mivitana.objectives.levelObjectives')}
        </div>
        <h3 className="no-data-hint">{t('block.not.updated.with.dates')}</h3>
      </div>
      <div className="level-objectives-content liveoben-level-objectives-content">
        <div className="level-objectives-labels-table">
          <table
            className="table table-striped m-table"
            style={{ width: '100%' }}
          >
            <tbody>
              <tr className="content" key="row-1">
                <td className="contentCell">
                  {t('report.laborigin.objectives.personalVA')}
                </td>
              </tr>
              <tr className="content" key="row-2">
                <td className="contentCell">
                  {t('report.laborigin.objectives.levelGroupVA')}
                </td>
              </tr>
              <tr className="content" key="row-3">
                <td className="contentCell">
                  {t('report.laborigin.objectives.activeDistributor')}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div className="level-card-container">
          {data.map((levelData, index) => (
            <LevelCard
              key={levelData.level}
              t={t}
              index={index}
              levelData={levelData}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

LevelObjectives.propTypes = {
  t: PropTypes.func.isRequired,
  data: PropTypes.arrayOf(
    PropTypes.shape({
      level: PropTypes.number.isRequired,
      skillLevel: PropTypes.shape({
        icon: PropTypes.string,
        name: PropTypes.string,
      }).isRequired,
      personalVA: PropTypes.shape({
        limit: PropTypes.number,
        limitAchieved: PropTypes.bool,
      }).isRequired,
      weakLegVA: PropTypes.shape({
        limit: PropTypes.number,
        limitAchieved: PropTypes.bool,
      }).isRequired,
      vaOnEachLeg: PropTypes.shape({
        limit: PropTypes.number,
        limitAchieved: PropTypes.bool,
      }).isRequired,
      recruitGoals: PropTypes.shape({
        recruitGoalLevel: PropTypes.number,
        recruitGoalAmount: PropTypes.number,
        recruitGoalAchieved: PropTypes.bool,
      }).isRequired,
    }),
  ).isRequired,
};

export default translate(LevelObjectives);
